<!-- <app-side-menu></app-side-menu> -->


<!-- Scope for Refactoring -  -->
<!-- Output for each asset can go here. Below conversation code can be toggled based on the asset. Would be nice to not to duplicate conversation component -->


<div class="chat-container">
  <div class="header">
    <h4><b>{{'genai_name' | translate}}</b> | Powered by Deloitte <span class="text-green"> .AI</span></h4>
    <!-- <p>Please bookmark the link of this page.</p> -->
  </div>
  <div id="chat-area">
    <div id="chats">
      <div class="chat-placeholder" *ngIf="!messages.length">
        <img [src]="chat_logo" alt="Logo"/>
        <p class="mt-3">Welcome to 
            <b>{{'genai_name' | translate}}</b> 
            powered by
            <b>Deloitte <span class="text-green"> .AI</span></b> 
        </p>
        <p>How can I assist you today?</p>
      </div>
      <div *ngFor="let message of messages" class="message-container">
        <div
          class="message {{ message.role }}  {{
            message.content ===
              'The OpenAI model that you are using is currently overloaded. Please try again later.' &&
              'error'
          }}"
        >
          <p>{{ message.content }}</p>
        </div>
      </div>
    </div>
    <p id="waiting-message" *ngIf="isLoading && waitingMessage">
      {{ waitingMessage }}
    </p>
  </div>
  <div class="chat-input">
    <!-- <mat-progress-bar
      mode="indeterminate"
      value="40"
      *ngIf="isLoading"
    ></mat-progress-bar> -->
    <mat-form-field appearance="outline">
      <mat-label>Send a message</mat-label>

      <textarea
        class="textarea1"
        matInput
        placeholder=""
        [(ngModel)]="prompt"
        (keyup.enter)="!isLoading && sendMessage()"
        #messagefocus
      ></textarea>
      <button
        class="send-button"
        [disabled]="isLoading || !this.prompt"
        (click)="sendMessage()"
        mat-icon-button
        matSuffix
      >
        <mat-icon matSuffix>send</mat-icon>
      </button>
      <!-- <mat-hint>Hint</mat-hint> -->
    </mat-form-field>
    <p class="warning-text">
      {{'genai_name' | translate}} may produce inaccurate information about people, places, or facts.
    </p>
  </div>
</div>
